ACC.lumifyAddendum = {
  lumifyAddendumLink: function() {
    $(document).on('click', '.lumifyAddendumLink', function() {
      ACC.lumifyAddendum.lumifyAddendumLinkClick();
    });
  },

  aedAddendumLink: function() {
    $(document).on('click', '.aedAddendumLink', function() {
      ACC.lumifyAddendum.aedAddendumLinkClick();
    });
  },

  aedAddendumLinkClick: function() {
    $.colorbox({
      href: $('.getAedAddendumUrl').text(),
      width: '100%',
      maxWidth: 640,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },

  lumifyAddendumLinkClick: function() {
    $.colorbox({
      href: $('.getLumifyAddendumUrl').text(),
      width: '100%',
      maxWidth: 640,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  }
};

$(document).ready(function() {
  ACC.lumifyAddendum.lumifyAddendumLink();
  ACC.lumifyAddendum.aedAddendumLink();
});

